<template>
  <!-- 2024.11.28 kouta.noborisaka 三井化学（市原工場）:横スクロールの設定 Start -->
  <div style="overflow-x: auto">
    <v-container style="min-width: 1000px">
      <!-- 2024.11.28 kouta.noborisaka 三井化学（市原工場）:横スクロールの設定 End -->
      <v-container class="noPaddingBtm">
        <v-card flat>
          <v-row>
            <v-col cols="5" class="headerTitle headerGroup noPaddingBtm">
              <v-row>
                <v-card-title style="height: 40px">物件グループ名</v-card-title>
                <v-col class="noPaddingBtm">
                  <ryou-select
                    class="ryouSelectStyle"
                    :items="dynamicItems"
                    :itemText="'build_group_name'"
                    :itemValue="'build_group_id'"
                    v-model="selectOptionValue"
                    :value="selectOptionValue"
                  >
                  </ryou-select>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="3" class="noPaddingBtm">
              <v-card-title class="OfferTitle">
                <h2>提供メニュー</h2>
              </v-card-title>
            </v-col>

            <v-col cols="4" class="noPaddingBtm">
              <v-row>
                <v-col cols="4" style="padding: 0px">
                  <v-card-title style="padding: 16px 0px 16px 45px"
                    >メニュー取込み</v-card-title
                  >
                </v-col>
                <v-col cols="4" style="padding: 0px 0px 12px">
                  <v-form ref="p2Form" v-model="p2Form" lazy-validation>
                    <v-file-input
                      label="ﾒﾆｭｰ登録ファイル"
                      v-model="chosenFile"
                      :rules="inputRulesFile"
                      truncate-length="14"
                    >
                    </v-file-input>
                  </v-form>
                </v-col>
                <v-col cols="4" style="padding: 0px 12px">
                  <v-card-actions>
                    <ryou-black-btn
                      :label="'アップロード'"
                      :handlerClick="importFile"
                      :iconCls="'mdi-file-upload'"
                    >
                    </ryou-black-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
      <v-container>
        <v-row>
          <v-col>
            <v-sheet height="64" style="margin-left: 43%">
              <v-toolbar flat>
                <v-btn
                  fab
                  text
                  small
                  color="grey darken-2"
                  @click="calendarPrv"
                  :disabled="arrowCtrlFlag"
                >
                  <v-icon x-calendar> mdi-chevron-left </v-icon>
                </v-btn>
                <v-toolbar-title>
                  <h2>{{ this.canderTitle }}</h2>
                </v-toolbar-title>
                <v-btn
                  fab
                  text
                  small
                  color="grey darken-2"
                  @click="calendarNext"
                  :disabled="arrowCtrlFlag"
                >
                  <v-icon x-large> mdi-chevron-right </v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <!--
    <v-card-actions >
      <ryou-black-btn :label="'一品読込'" :handlerClick="oneOutFile" :iconCls="'mdi-file-upload'">
      </ryou-black-btn>
    </v-card-actions>
    <v-form ref="p3Form" v-model="p3Form" lazy-validation style="width:200px">
      <v-file-input label="一品登録ファイル" v-model="oneChoseFile" :rules="oneInputRulesFile" truncate-length="14">
      </v-file-input>
    </v-form>
    <v-card-actions>
      <ryou-black-btn :label="'一品登録'" :handlerClick="oneImportFile" :iconCls="'mdi-file-upload'">
      </ryou-black-btn>
    </v-card-actions>
    <v-card-actions v-if="displayFlag">
      <ryou-black-btn :label="'一括提供設定'" :handlerClick="openCollectiveDialog" :disabled="!collectiveBtnCtrl">
      </ryou-black-btn>
    </v-card-actions>
          -->
              </v-toolbar>
            </v-sheet>
            <!-- 2024.11.28 kouta.noborisaka 三井化学（市原工場）:高さ指定「height="600"」を削除 -->
            <v-sheet>
              <!-- 2024.11.28 kouta.noborisaka 三井化学（市原工場）:メニュー名を省略表示しないように「:event-more="false"」を追加 -->
              <v-calendar
                ref="calendar"
                v-model="focus"
                color="primary"
                :events="events"
                :event-more="false"
                :type="type"
                @click:event="showEvent"
                @click:date="btnClick($event)"
              >
                <template v-slot:day="props">
                  <template v-for="(ent, index) in notOfferEventsDateList">
                    <div
                      :key="index"
                      class="disable"
                      v-if="ent == props.date"
                      style="text-align: center"
                    >
                      提供無し
                    </div>
                  </template>
                </template>
                <template v-slot:event="{ event }">
                  <v-row>
                    <!-- 2024.11.28 kouta.noborisaka 三井化学（市原工場）:styleに「white-space: normal」を追加 -->
                    <v-col style="text-align: center; white-space: normal">
                      {{ event.name }}
                    </v-col>
                  </v-row>
                </template>
              </v-calendar>
            </v-sheet>
            <MealLunchDialog
              ref="modalLunch"
              @reCalendar="calendarGet"
            ></MealLunchDialog>
            <MealLunchCollectiveDialog
              ref="modalCollective"
              :mealNames="mealNames"
              :mealDeadLineDay="mealDeadLineDay"
              :buildGroupId="selectOptionValue"
              @reCalendar="calendarGet"
            ></MealLunchCollectiveDialog>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </div>
</template>

<script>
import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
import RyouSelect from "../../components/formInput/RyouSelect";
import MealLunchDialog from "./modules/MealLunchDialog.vue";
import MealLunchCollectiveDialog from "./modules/MealLunchCollectiveDialog.vue";
import { postUploadRequest } from "@/utils/api";
import fileDownload from "js-file-download";
export default {
  name: "MealLunchSetting",
  components: {
    RyouBlackBtn,
    RyouSelect,
    MealLunchDialog,
    MealLunchCollectiveDialog,
  },
  data() {
    return {
      p2Form: true,
      p3Form: true,
      inputRulesFile: [],
      oneInputRulesFile: [],
      focus: "",
      type: "month",
      canderTitle: "", //カレンダーのヘッダ
      mealDeadLineDay: "", //締め切りの日
      hasEventsDateList: [], //メニューが存在する日付["YYYY-MM-dd","YYYY-MM-dd",...]
      hasEventsDateDetailedDataList: [], //メニューが存在する詳細データ
      mealNames: [], //日付の食事名[食事一,食事二,...]
      events: [], //メニューが存在毎日のイベント[ある日の食事一,食事二,...]
      notOfferEventsDateList: [], //提供無し日付["YYYY-MM-dd","YYYY-MM-dd",...]
      notOfferEventsDateDetailedDataList: [], //提供無し日付詳細データ
      chosenFile: null,
      oneChoseFile: null,
      selectOptionValue: "",
      dynamicItems: [],
      colors: [
        "#FF9800", //オレンジ
        "#673AB7", //深紫
        "#4CAF50", //緑
        "#E91E63", //ピンク
        "#3F51B5", //インディゴ
        "#009688", //teal
        "#FF5722", //深オレンジ
        "#8BC34A", //light-green
        "#D32F2F", //red darken-2
        "#1565C0", //blue darken-3
      ],
      arrowCtrlFlag: false,
      collectiveBtnCtrl: false, //一括提供設定ボタンコントロール
      displayFlag: false, //一括提供設定ボタン表示フラグ
    };
  },
  created() {
    this.initData();
  },
  mounted() {
    this.inputRulesFile.push(this.GlobalRules.required);
    this.oneInputRulesFile.push(this.GlobalRules.required);
    this.canderTitle = this.initCanderValue(this.$refs.calendar.title);
  },
  watch: {
    selectOptionValue(value) {
      if (value != "") {
        this.calendarGet();
        this.collectiveBtnCtrl = true;
      } else {
        this.collectiveBtnCtrl = false;
      }
    },
    canderTitle() {
      if (this.selectOptionValue != "") {
        this.calendarGet();
      }
    },
  },
  methods: {
    //日付をクリック
    btnClick(date) {
      this.canderTitle = date.year + "年" + date.month + "月";
      let getNowMonth = this.$refs.calendar.title.split("月 ");

      // 当月かどうかを判断
      if (date.month == getNowMonth[0]) {
        let DialogData = this.calendarDialogDataGet(date.date);
        if (DialogData) {
          // パラメータ1:ダイアログデータ、パラメータ2:物件グループID
          // パラメータ3:食事提供有無フラグ、パラメータ4:締め切りフラグ
          // パラメータ5:[食事区分&食事名]
          this.$refs.modalLunch.getInputValue(
            DialogData,
            this.selectOptionValue,
            true,
            date.date < this.mealDeadLineDay,
            this.mealNames
          );
        } else {
          DialogData = this.calendarDialogNotOfferDataGet(date.date);
          if (DialogData) {
            // パラメータ1:ダイアログデータ、パラメータ2:物件グループID
            // パラメータ3:食事提供有無フラグ、パラメータ4:締め切りフラグ
            // パラメータ5:[食事区分&食事名]
            this.$refs.modalLunch.getInputValue(
              DialogData,
              this.selectOptionValue,
              false,
              date.date < this.mealDeadLineDay,
              this.mealNames
            );
          } else {
            this.$refs.modalLunch.getInputValue(date.date);
          }
        }
      }
    },
    //イベントクリック
    showEvent(event) {
      let DialogData = this.calendarDialogDataGet(event.day.date);
      if (DialogData) {
        // パラメータ1:ダイアログデータ、パラメータ2:物件グループID
        // パラメータ3:食事提供有無フラグ、パラメータ4:締め切りフラグ
        // パラメータ5:[食事区分&食事名]
        this.$refs.modalLunch.getInputValue(
          DialogData,
          this.selectOptionValue,
          true,
          event.day.date < this.mealDeadLineDay,
          this.mealNames
        );
      } else {
        this.$refs.modalLunch.getInputValue(event.day.date);
      }
    },
    initData() {
      let params = {
        userId: this.$store.getters.getUserId,
        userClass: this.$store.getters.getUserClass,
      };
      //selectBoxで値を取る
      this.getRequest(
        "/mealLunchSetting/buildGroupGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          this.dynamicItems = data.result;
          // 物件グループの初期値セット
          if (this.$store.getters.getBuilGroupId != null) {
            this.selectOptionValue = this.$store.getters.getBuilGroupId;
          }
        }
      });
    },
    //一括登録
    importFile() {
      var valid = this.$refs.p2Form.validate();
      if (valid) {
        let formData = new FormData();
        formData.append("file", this.chosenFile);

        let paramsSelect = this.selectOptionValue;
        // 未選択はNGとする
        if (paramsSelect == "") {
          this.$toast.open({
            message: "物件グループ名を選択してください。",
            type: "warning",
          });
          return;
        }

        let url =
          "/mealLunchSetting/fileInsertUpdate" +
          "/" +
          this.$store.getters.getUserId +
          "/" +
          paramsSelect;

        postUploadRequest(url, formData, this.$store.getters.getUserToken).then(
          (resp) => {
            if (resp.success) {
              this.calendarGet();
            }
          }
        );
      }
    },
    // 一品登録
    oneImportFile() {
      var valid = this.$refs.p3Form.validate();
      if (valid) {
        let formData = new FormData();
        formData.append("file", this.oneChoseFile);

        let paramSelect = this.selectOptionValue;
        if (paramSelect == "") {
          this.$toast.open({
            message: "物件グループ名を選択してください。",
            type: "warning",
          });
          return;
        }
        // 一品ファイルアップロード
        let url =
          "/mealLunchSetting/oneFileInsertUpdate" +
          "/" +
          this.$store.getters.getUserId +
          "/" +
          paramSelect;

        postUploadRequest(url, formData, this.$store.getters.getUserToken).then(
          (resp) => {
            if (resp.success) {
              this.calendarGet();
            }
          }
        );
      }
    },
    // 一品取り込み
    oneOutFile() {
      let paramSelect = this.selectOptionValue;
      if (paramSelect == "") {
        this.$toast.open({
          message: "物件グループ名を選択してください。",
          type: "warning",
        });
        return;
      }
      this.selected = this.selectionRows;
      //CSV作成
      this.postRequest(
        "/mealLunchSetting/oneMealCSVGet/" +
          this.$store.getters.getUserId +
          "/" +
          paramSelect,
        null,
        this.$store.getters.getUserToken
      ).then((resp) => {
        //ファイルパスは戻り
        if (resp.success) {
          let streamParams = {
            filePath: resp.result,
          };
          //csvはダウンロード
          this.getStreamRequest(
            "/mealLunchSetting/oneMealDownLoadFile",
            streamParams,
            this.$store.getters.getUserToken
          )
            .then((res) => {
              const blob = new Blob([res], {
                type: "application/octet-stream;charset=utf-8",
              });
              return fileDownload(blob, "一品登録" + ".csv");
            })
            .catch(function (error) {
              // console.log(error);
            });
        }
      });
    },
    //提供一括登録
    openCollectiveDialog() {
      this.$refs.modalCollective.open();
    },
    //カレンダーデータ取得
    calendarGet() {
      // データクリア
      this.mealNames = [];
      this.events = [];
      this.hasEventsDateList = [];
      this.hasEventsDateDetailedDataList = [];
      this.notOfferEventsDateList = [];
      this.notOfferEventsDateDetailedDataList = [];
      this.$(".v-calendar-weekly__day:has(div.disable)").removeClass("mask");
      this.$("div.disable").remove();

      if (this.selectOptionValue != null && this.selectOptionValue != "") {
        var that = this;

        let mealClassDeadLineParams = {
          buildGroupId: this.selectOptionValue,
        };

        this.getRequest(
          "/mealLunchSetting/mealClassGet",
          mealClassDeadLineParams,
          this.$store.getters.getUserToken
        ).then((data) => {
          // 食事区分取得
          if (data.success) {
            that.mealNames = data.result;
          }
        });

        this.getRequest(
          "/mealLunchSetting/mealDeadLineGet",
          mealClassDeadLineParams,
          this.$store.getters.getUserToken
        ).then((data) => {
          // 食事締め切り日取得
          if (data.success) {
            that.mealDeadLineDay = data.result;
          }
        });

        //年月取得
        let titleYear = this.canderTitle.split("年");
        let titleMonth = titleYear[1].split("月");
        let calendarParams = {
          buildGroupId: this.selectOptionValue,
          currentYM: titleYear[0] + "-" + titleMonth[0],
        };

        this.arrowCtrlFlag = true;

        //食事提供・メニューデータを取得し、提供ありリスト、提供なしリストに分ける
        this.getRequest(
          "/mealLunchSetting/calendarGet",
          calendarParams,
          this.$store.getters.getUserToken
        ).then((data) => {
          if (data.success) {
            // 現在の月を循環
            for (
              let dateIndex = 0;
              dateIndex < data.result.length;
              dateIndex++
            ) {
              //取得当日
              let dateItem = data.result[dateIndex];
              // 取得当日(Key,Value)
              for (let dateKey in dateItem) {
                //取得当日データ
                let dateData = dateItem[dateKey];
                // 取得当日データあり
                if (dateData.length != 0) {
                  // データが存在する日付
                  if (dateData[0].offer_flg == "1") {
                    //食事提供あり結果セット
                    if (that.hasEventsDateList.indexOf(dateKey) < 0) {
                      that.hasEventsDateList.push(dateKey);
                      that.hasEventsDateDetailedDataList.push(dateItem);
                    }
                  } else if (dateData[0].offer_flg == "0") {
                    //食事提供なし結果セット
                    if (that.notOfferEventsDateList.indexOf(dateKey) < 0) {
                      that.notOfferEventsDateList.push(dateKey);
                      that.notOfferEventsDateDetailedDataList.push(dateItem);
                    }
                  }
                }
              }
            }
            this.getValue();
          }
          this.arrowCtrlFlag = false;
        });
      }
    },
    //カレンダー、ポップアップ、データ取得
    //イベント、日付選択時のポップアップに使用するデータを「提供ありリスト」から取得
    calendarDialogDataGet(value) {
      for (
        let hedddIndex = 0;
        hedddIndex < this.hasEventsDateDetailedDataList.length;
        hedddIndex++
      ) {
        let hedddItem = this.hasEventsDateDetailedDataList[hedddIndex];

        for (let hedddKey in hedddItem) {
          if (hedddKey == value) {
            return hedddItem;
          }
        }
      }
    },
    //カレンダー、ポップアップ、データ取得(提供なし)
    //イベント、日付選択時のポップアップに使用するデータを「提供なしリスト」から取得
    calendarDialogNotOfferDataGet(value) {
      for (
        let noedddIndex = 0;
        noedddIndex < this.notOfferEventsDateDetailedDataList.length;
        noedddIndex++
      ) {
        let noedddItem = this.notOfferEventsDateDetailedDataList[noedddIndex];

        for (let noedddKey in noedddItem) {
          if (noedddKey == value) {
            return noedddItem;
          }
        }
      }
    },
    //カレンダーヘッドの初期化時間
    initCanderValue(tilte) {
      let titleList = tilte.split("月 ");
      let newTitile = titleList[1] + "年" + titleList[0] + "月";

      return newTitile;
    },
    //カレンダーの来月
    calendarNext() {
      this.$refs.calendar.next();

      setTimeout(() => {
        this.canderTitle = this.initCanderValue(this.$refs.calendar.title);
      }, 100);

      this.getValue();
    },
    //カレンダーの前の月
    calendarPrv() {
      this.$refs.calendar.prev();

      setTimeout(() => {
        this.canderTitle = this.initCanderValue(this.$refs.calendar.title);
      }, 100);

      this.getValue();
    },
    //カレンダーデータのロードが完了しました。
    getValue() {
      // データが存在する日食、事区分表示
      for (
        let dateIndex = 0;
        dateIndex < this.hasEventsDateDetailedDataList.length;
        dateIndex++
      ) {
        //当日の食事は区分表示
        for (
          let menuCount = 0;
          menuCount < this.mealNames.length;
          menuCount++
        ) {
          let hasEventsDateDetailedDataItem =
            this.hasEventsDateDetailedDataList[dateIndex];
          for (let hedddiKey in hasEventsDateDetailedDataItem) {
            let hasEventsDateDetailedDataItemValue =
              hasEventsDateDetailedDataItem[hedddiKey];
            for (
              let hedddivIndex = 0;
              hedddivIndex < hasEventsDateDetailedDataItemValue.length;
              hedddivIndex++
            ) {
              //カレンダーイベントに「提供ありリスト」のデータを追加
              if (
                this.mealNames[menuCount].meal_class ==
                hasEventsDateDetailedDataItemValue[hedddivIndex].meal_class
              ) {
                if (hedddiKey < this.mealDeadLineDay) {
                  if (
                    hasEventsDateDetailedDataItemValue[hedddivIndex]
                      .holiday_flg == "1"
                  ) {
                    //締め切り日を過ぎている
                    this.events.push({
                      name: hasEventsDateDetailedDataItemValue[hedddivIndex]
                        .menu,
                      start: hedddiKey,
                      color:
                        hasEventsDateDetailedDataItemValue[hedddivIndex]
                          .offer_flg_mc == "1"
                          ? "#800000"
                          : "#bebebe",
                      timed: false,
                    });
                  } else {
                    //締め切り日を過ぎている
                    this.events.push({
                      name: hasEventsDateDetailedDataItemValue[hedddivIndex]
                        .menu,
                      start: hedddiKey,
                      color:
                        hasEventsDateDetailedDataItemValue[hedddivIndex]
                          .offer_flg_mc == "1"
                          ? "#795548"
                          : "#bebebe",
                      timed: false,
                    });
                  }
                } else {
                  if (
                    hasEventsDateDetailedDataItemValue[hedddivIndex]
                      .holiday_flg == "1"
                  ) {
                    this.events.push({
                      name: hasEventsDateDetailedDataItemValue[hedddivIndex]
                        .menu,
                      start: hedddiKey,
                      color:
                        hasEventsDateDetailedDataItemValue[hedddivIndex]
                          .offer_flg_mc == "1"
                          ? "#800000"
                          : "#bebebe",
                      timed: false,
                    });
                  } else {
                    this.events.push({
                      name: hasEventsDateDetailedDataItemValue[hedddivIndex]
                        .menu,
                      start: hedddiKey,
                      color:
                        hasEventsDateDetailedDataItemValue[hedddivIndex]
                          .offer_flg_mc == "1"
                          ? this.colors[menuCount]
                          : "#bebebe",
                      timed: false,
                    });
                  }
                }

                break;
              } else {
                //いつ通るか不明
                if (
                  hedddivIndex ==
                  hasEventsDateDetailedDataItemValue.length - 1
                ) {
                  if (hedddiKey < this.mealDeadLineDay) {
                    this.events.push({
                      name: "",
                      start: hedddiKey,
                      color: "#795548",
                      timed: false,
                    });
                  } else {
                    this.events.push({
                      name: "",
                      start: hedddiKey,
                      color: this.colors[menuCount],
                      timed: false,
                    });
                  }
                }
              }
            }
          }
        }
      }

      setTimeout(() => {
        // disableを含む要素を見つけて、スタイルを追加します
        this.$(".v-calendar-weekly__day:has(div.disable)").addClass("mask");
      }, 100);
    },
  },
};
</script>

<style lang="scss">
.noPaddingBtm {
  padding-bottom: 0px;
}

.ryouSelectStyle {
  width: 250px;
  height: 40px;
}

.OfferTitle {
  padding: 0px 55px;
}

.mask {
  box-sizing: border-box;
  border: 1px solid #9e9e9e !important;
  background-color: #bebebe !important;
}

// 2024.11.28 kouta.noborisaka 三井化学（市原工場）:スタイルの定義 Start
.v-event {
  height: auto !important; // 要素の高さを可変にする
}
// 2024.11.28 kouta.noborisaka 三井化学（市原工場）:スタイルの定義 End
</style>
